import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {customBaseQuery} from "@common/services/api.service";
import {BaseQueryArg} from "@reduxjs/toolkit/dist/query/baseQueryTypes";

const traceabilityApi = createApi({
    reducerPath: 'traceabilityApi',
    baseQuery: customBaseQuery(),
    endpoints: (build) => ({
        getUsersList: build.query<any, void>({
            query: () => {
                return {
                    url: 'user',
                    method: 'GET',
                }
            }
        }),
        addUser: build.mutation({
            query: (payload: any) => {
                return {
                    url: 'user',
                    method: 'POST',
                    data: payload,
                }
            }
        })
    }),
});

export const { useGetUsersListQuery, useAddUserMutation } = traceabilityApi;
export default traceabilityApi;